import React from 'react';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type StatusCellType from './main.tsx';
import StatusCell from './main.tsx';
import type { StatusCellProps } from './types.tsx';

const LazyStatusCell = lazyForPaint<typeof StatusCellType>(
	() => import(/* webpackChunkName: "async-status-cell" */ './main'),
);

const AsyncStatusCell = (props: StatusCellProps) => (
	<Placeholder name="status-cell" fallback={null}>
		<LazyStatusCell {...props} />
	</Placeholder>
);

export default componentWithFG('list_view_sync_cells', StatusCell, AsyncStatusCell);
